export enum WarehouseInventoryMenuEnum {
    overview = 0,
    neighborhood,
    properties
}
